import Action from './action';

const initialState = {
    userName: '',
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_USER_NAME: {
            return {
                ...state,
                userName: action.playload
            }
        }
        case Action.UPDATE_USER_NAME_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('username_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
